module.exports = __webpack_public_path__ + "static/img/kolorowanka-80px.8a8ac83c.png";